import React, { useState } from 'react';
import { Tabs } from 'antd';
import type { Application } from '../../types';
import type { WorkspaceTask } from '../../store/api/workspaceApi';
import { useGetApplicationTaskHistoryQuery } from '../../store/api/workspaceApi';
import { WorkspaceApplicationTasks } from '../workspace/WorkspaceTasks';
import ApplicationTaskModalHost from './ApplicationTaskModalHost';
import TaskHistoryTable from '../tasks/TaskHistoryTable';

export interface ApplicationTasksTabProps {
  application: Application;
  tasks: WorkspaceTask[];
  onTaskSuccess?: () => void | Promise<void>;
}

const ApplicationTasksTab: React.FC<ApplicationTasksTabProps> = ({
  application,
  tasks,
  onTaskSuccess,
}) => {
  const [activeTask, setActiveTask] = useState<WorkspaceTask | null>(null);
  const [activeTab, setActiveTab] = useState<'active' | 'history'>('active');

  const {
    data: historyPage,
    isLoading: historyLoading,
    isFetching: historyFetching,
  } = useGetApplicationTaskHistoryQuery(application.id, {
    skip: activeTab !== 'history',
  });

  const historyItems = historyPage?.items ?? [];

  return (
    <>
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key === 'history' ? 'history' : 'active')}
        items={[
          {
            key: 'active',
            label: 'Активные',
            children: (
              <WorkspaceApplicationTasks
                tasks={tasks}
                onTaskAction={setActiveTask}
                activeActionTaskId={activeTask?.id ?? null}
                maxHeight={520}
                bodyPadding={8}
                groupTasksPadding="4px 8px 6px"
                title="Задачи заявки"
              />
            ),
          },
          {
            key: 'history',
            label: 'История',
            children: (
              <TaskHistoryTable
                items={historyItems}
                loading={historyLoading || historyFetching}
              />
            ),
          },
        ]}
      />
      <ApplicationTaskModalHost
        task={activeTask}
        onClose={() => setActiveTask(null)}
        onSuccess={async () => {
          setActiveTask(null);
          await onTaskSuccess?.();
        }}
      />
    </>
  );
};

export default ApplicationTasksTab;
